import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import Error404 from "../../components/Error404";
import MainContainer from "../../components/MainContainer";
import * as ArticleController from "../../controllers/article-controller";
import * as AuthorController from "../../controllers/author-controller";
import UserStore from "../../store/UserStore";
import Article from "./Article";

interface IProps {}

interface IData {
  article: ArticleDetail;
  author: AuthorResponse;
}

function DraftArticle({}: IProps) {
  const router = useRouter();
  const [data, setData] = useState<IData>();

  const { isAuth } = UserStore;

  useEffect(() => {
    const getArticle = async () => {
      const index = router.query.article as string;
      const response = await ArticleController.getDraftArticleByIndex(index);

      const article = response;
      if (article) {
        const author = await AuthorController.getAuthorById(article?.author_id);
        author && setData({ article, author });
      }
    };
    isAuth && getArticle();
  }, [router.query.article, isAuth]);

  if (!data) return <Error404 />;

  const { article, author } = data;

  return (
    <MainContainer>
      <section className="article-page-section">
        <div className="wrap">
          <div className="main-columns article-page">
            <div className="main-columns__aside aside article-page__aside">
              {/* <RecommendedRandom
                tagslug={article.tagslug}
                excludeId={article.article_id}
              /> */}
            </div>
            <div className="main-columns__center article-page__center">
              <Article
                key={article.article_id}
                article={article}
                author={author}
              />
            </div>
          </div>
        </div>
      </section>
    </MainContainer>
  );
}

export default observer(DraftArticle);
